var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"answer-trend__container"},[_c('svg',{staticClass:"answer-trend__container__svg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }